import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ClusterChangedEvent, ClusterClickEvent } from './cluster.models';
import { FeatureEvent } from '../drawing/features/feature.model';

@Injectable({
  providedIn: 'root'
})
export class MapEventsService implements OnDestroy {
  featureClick$: Subject<FeatureEvent> = new Subject();
  featureDoubleClick$: Subject<FeatureEvent> = new Subject();
  clusterClick$: Subject<ClusterClickEvent> = new Subject();
  clusterDoubleClick$: Subject<ClusterClickEvent> = new Subject();
  clusterChanged$: Subject<ClusterChangedEvent> = new Subject();
  saveDocumentClick$: Subject<void> = new Subject();
  doubleClickMarker$: Subject<FeatureEvent> = new Subject();
  mapBoundsChanged$: Subject<string[]> = new Subject();
  mapZoomChanged$: Subject<void> = new Subject();
  mapStreetViewChanged$: Subject<void> = new Subject();
  mapClick$: Subject<{ lat: number; lng: number }> = new Subject();
  markerMouseOver$: Subject<FeatureEvent> = new Subject();
  markerMouseOut$: Subject<FeatureEvent> = new Subject();
  timelineDateChanged$: Subject<any> = new Subject();

  onStreetViewChanged() {
    this.mapStreetViewChanged$.next();
  }

  onFeatureClick(e: FeatureEvent) {
    this.featureClick$.next(e);
  }

  onClusterClick(e: ClusterClickEvent) {
    this.clusterClick$.next(e);
  }

  onClusterDoubleClick(e: ClusterClickEvent) {
    this.clusterDoubleClick$.next(e);
  }

  onClusterChangedNotify(e: ClusterChangedEvent) {
    this.clusterChanged$.next(e);
  }

  onSaveDocumentClick() {
    this.saveDocumentClick$.next();
  }

  onFeatureDoubleClick(e: FeatureEvent) {
    this.featureDoubleClick$.next(e);
  }

  onMapZoomChanged() {
    this.mapZoomChanged$.next();
  }

  onMapBoundsChanged(visibleLayerUIds: string[]) {
    this.mapBoundsChanged$.next(visibleLayerUIds);
  }

  onMapClick(e: any) {
    const { lat, lng } = e.latLng.toJSON();
    this.mapClick$.next({ lat, lng });
  }

  onMarkerMouseOver(e: FeatureEvent) {
    this.markerMouseOver$.next(e);
  }

  onMarkerMouseOut(e: FeatureEvent) {
    this.markerMouseOut$.next(e);
  }

  onTimelineDateChanged(d: any) {
    this.timelineDateChanged$.next(d);
  }

  ngOnDestroy() {
    this.featureClick$.complete();
    this.featureClick$ = null;
    this.clusterClick$.complete();
    this.clusterClick$ = null;
    this.clusterDoubleClick$.complete();
    this.clusterDoubleClick$ = null;
    this.clusterChanged$.complete();
    this.clusterChanged$ = null;
    this.saveDocumentClick$.complete();
    this.saveDocumentClick$ = null;
    this.featureDoubleClick$.complete();
    this.featureDoubleClick$ = null;
    this.mapZoomChanged$.complete();
    this.mapZoomChanged$ = null;
    this.mapBoundsChanged$.complete();
    this.mapBoundsChanged$ = null;
    this.mapStreetViewChanged$.complete();
    this.mapStreetViewChanged$ = null;
    this.mapClick$.complete();
    this.mapClick$ = null;
    this.markerMouseOver$.complete();
    this.markerMouseOver$ = null;
    this.markerMouseOut$.complete();
    this.markerMouseOut$ = null;
    this.timelineDateChanged$.complete();
    this.timelineDateChanged$ = null;
  }
}
